import DailyChallenge from "./DailyChallenge";
import MonthlyChallenge from "./MonthlyChallenge";
import type { ChallengeProgress } from "@/types/extended-types";

type ChallengesProps = {
  donePercentageDaily: number;
  notdonePercentageDaily: number;
  donePercentageMonthly: number;
  notdonePercentageMonthly: number;
  challengesData?: ChallengeProgress;
};
const Challenges = ({
  donePercentageDaily,
  notdonePercentageDaily,
  donePercentageMonthly,
  notdonePercentageMonthly,
  challengesData,
}: ChallengesProps) => {
  return (
    <div className="flex flex-col lg:flex-row items-center justify-between gap-7 mb-9">
      <DailyChallenge
        donePercentage={donePercentageDaily}
        notDonePercentage={notdonePercentageDaily}
        dailyData={challengesData?.daily}
      />
      <MonthlyChallenge
        donePercentage={donePercentageMonthly}
        notDonePercentage={notdonePercentageMonthly}
        monthlyData={challengesData?.monthly}
      />
    </div>
  );
};
export default Challenges;
